const getters = {
    GetCurrentState: (state, getters) => (currentpath) => {
        //获取当前组件的BillOpState
        for (let index = 0; index < state.browseRecord.length; index++) {
            const element = state.browseRecord[index];
            if (currentpath == element.key) {
                return element.BillOpState;
            }
        }
    },
    GetBeforeOpState: (state, getters) => (currentpath) => {
        //获取当前组件的BillOpState
        for (let index = 0; index < state.browseRecord.length; index++) {
            const element = state.browseRecord[index];
            if (currentpath == element.key) {
                return element.BeforeOpState;
            }
        }
    },
    GetCurrentValue: (state, getters) => (currentpath) => {
        //获取当前组件的brData
        for (let index = 0; index < state.browseRecord.length; index++) {
            const element = state.browseRecord[index];
            if (currentpath == element.key) {
                return element.brData;
            }
        }
    },
    GetisOpenRouter:(state , getters) => () =>{
        return state.isOpenRouter
    },
    GetBrowseRecord: (state, getters) => (currentpath) => {
        return state.browseRecord;
    }
}
export default getters;